// export const AboutContent = {
//   sideImage: "./images/yc-logo.jpeg",
//   heading: "About Us",
//   text: [
//     {
//       type: "highlight",
//       value:
//         "Welcome to Yum Canal — a fine-dining, family-friendly restaurant where taste flows to your plate.",
//     },
//     {
//       type: "normal",
//       parts: [
//         "At Yum Canal, we bring together ",
//         { strong: true, value: "amazing flavors and thoughtfully crafted dishes" },
//         " across ",
//         { strong: true, value: "Indian, Continental, Chinese, and Tandoor cuisines" },
//         ". Every recipe is prepared with care, using ",
//         { strong: true, value: "high-quality ingredients" },
//         ", ",
//         { strong: true, value: "authentic techniques" },
//         ", and a touch of creativity—so every bite feels special.",
//       ],
//     },
//     {
//       type: "normal",
//       parts: [
//         "More than just a meal, Yum Canal is a place to ",
//         { strong: true, value: "celebrate happy vibes" },
//         "—",
//         { strong: true, value: "family dinners, friendly catch-ups, and memorable evenings" },
//         ". With a ",
//         { strong: true, value: "warm ambience" },
//         ", ",
//         { strong: true, value: "attentive service" },
//         ", and a menu designed to delight every palate, we make sure your dining experience is as satisfying as the food itself.",
//       ],
//     },
//     {
//       type: "highlight",
//       value: "Come for the flavors, stay for the moments—Yum Canal: Where taste flows to your plate.",
//     },
//   ],
// };




export const AboutContent = {
  sideImage: "./images/yc-logo.jpeg",
  heading: "About Us",
  tagline: "Where taste flows to your plate",
  text: `Welcome to Yum Canal — a fine-dining, family-friendly restaurant.

At Yum Canal, we bring together amazing flavors and thoughtfully crafted dishes across Indian, Continental, Chinese, and Tandoor cuisines. Every recipe is prepared with care, using high-quality ingredients, authentic techniques, and a touch of creativity—so every bite feels special.

More than just a meal, Yum Canal is a place to celebrate happy vibes—family dinners, friendly catch-ups, and memorable evenings. With a warm ambience, attentive service, and a menu designed to delight every palate, we make sure your dining experience is as satisfying as the food itself.

Come for the flavors, stay for the moments.`,
};

